<template>
  <div class="dataContent">
    <div class="dataTitle">我的数据<span class="dataTitleTips">（仅统计个人提交的数据）</span></div>
    <div>
      <h3 class="bold" style="margin: 10px 0 0 20px">我的数据概况（分阶段统计）</h3>
      <Echarts :xAxisData="xAxisData" :seriesData="seriesData" :eachartsRefresh="eachartsRefresh" />
      <!-- <div style="width: 40%;float: left;padding: 20px;">
        <h3 class="bold" >数据统计说明</h3>
        1、<span class="bold">单阶段数据</span>：如教槽、保育前期等，指实证中仅填写单一阶段的数据。若填写阶段超出1个，则不属于单阶段数据。<br />
        2、<span class="bold">全程数据</span>：指实证体重区间≥100kg，或填写全部7个实证阶段的数据<br />
        3、<span class="bold">其他</span>：指即不属于单阶段，又不属于全程的数据。<span class="red">该类数据正常纳入统计，暂不纳入分析</span><br />
        4、<span class="bold">异常数据</span>：指料肉比异常（{{lessThan}}0.5或{{greaterThan}}10 ）或造肉成本异常（{{lessThan}}1 或{{greaterThan}}20）的数据。<span class="red">该类数据正常纳入统计，暂不纳入分析</span>
      </div> -->
      <!-- <div style="clear: both;"></div> -->
    </div>
    <h3 class="bold" style="margin-bottom: 0;margin-left: 20px;">我的实证排名</h3>
    <p style="font-size: 12px;color: #ccc;margin-bottom: 0;margin-left: 20px;">排名数据实时计算</p>
    <a-table
      style="padding: 20px;"
      ref="listRef"
      row-key="id"
      :columns="columns"
      :data-source="list"
      :pagination="pagination"
      :scroll="{x: 100,y: 300}"
      bordered
    >
      <template slot="customLabelName">
        <a-select v-model="classLabel" style="width: 100px;">
          <a-select-option value="">全部分类</a-select-option>
          <a-select-option value="PIGLET">教槽</a-select-option>
          <a-select-option value="CHILDCARE_BEFORE">保育前期</a-select-option>
          <a-select-option value="CHILDCARE_AFTER">保育后期</a-select-option>
          <a-select-option value="LITTLE_PIG">仔猪</a-select-option>
          <a-select-option value="MEDIUM">生长猪</a-select-option>
          <a-select-option value="FATTENING_PIG">育肥猪</a-select-option>
          <a-select-option value="LARGE_PIG">大猪</a-select-option>
          <a-select-option value="ALL_STAGE">全程</a-select-option>
          <a-select-option value="OTHER">其他</a-select-option>
          <a-select-option value="EXCEPTION">异常数据</a-select-option>
        </a-select>
        <a-tooltip>
          <template slot="title">数据分类说明</template>
          <a-icon type="question-circle" theme="filled" style="color: gray;" @click="() => openTips(0)" />
        </a-tooltip>
      </template>
      <span slot="customWeightCostRatioRank">
        料肉比同阶段排名
        <span style="display: inline-block;height: 10px;width: 10px;font-size: 10px;position: relative;">
          <a-icon :class="sortParams.ascs === 'weightCostRatioRank' ? 'blue' : ''" type="caret-up" @click="() => changeSort('ascs','weightCostRatioRank')" style="position: absolute;top: 0px;" /><br />
          <a-icon :class="sortParams.descs === 'weightCostRatioRank' ? 'blue' : ''" type="caret-down" @click="() => changeSort('descs','weightCostRatioRank')" style="position: absolute;top: 8px;" />
        </span>
        <a-tooltip>
          <template slot="title">同阶段排名说明</template>
          <a-icon type="question-circle" theme="filled" style="color: gray;" @click="() => openTips(1)" />
        </a-tooltip>
      </span>
      <span slot="customMealProductCostRank">
        造肉成本同阶段排名
        <span style="display: inline-block;height: 10px;width: 10px;font-size: 10px;position: relative;">
          <a-icon :class="sortParams.ascs === 'mealProductCostRank' ? 'blue' : ''" type="caret-up" @click="() => changeSort('ascs','mealProductCostRank')" style="position: absolute;top: 0px;" /><br />
          <a-icon :class="sortParams.descs === 'mealProductCostRank' ? 'blue' : ''" type="caret-down" @click="() => changeSort('descs','mealProductCostRank')" style="position: absolute;top: 8px;" />
        </span>
        <a-tooltip>
          <template slot="title">同阶段排名说明</template>
          <a-icon type="question-circle" theme="filled" style="color: gray;" @click="() => openTips(1)" />
        </a-tooltip>
      </span>
      <template slot="name" slot-scope="t">
        <a-tooltip>
          <template slot="title">{{ t }}</template>
          {{ t }}
        </a-tooltip>
      </template>
      <a-tooltip slot="fixed2" slot-scope="t">
        <template slot="title">{{ t || t === 0 ? Number(t).toFixed(2) : t }}</template>
        {{ t || t === 0 ? Number(t).toFixed(2) : t }}
      </a-tooltip>
      <template slot="time" slot-scope="t,r">
        <a-tooltip>
          <template slot="title">{{ r.intoDay }} 至 {{ r.outDay }}</template>
          {{ r.intoDay }} 至 {{ r.outDay }}
        </a-tooltip>
      </template>
      <a-tooltip slot="rank" slot-scope="t">
        <template slot="title"></template>
        {{ t ? `前${t}%` : '-' }}
      </a-tooltip>
    </a-table>
  </div>
</template>

<script>
// import moment from 'moment'
import api from '../api.js'
import {myRankColumns} from '../Columns'
import Echarts from './CommonConponents/Echarts.vue';
export default {
  components: {
    Echarts,
  },
  props: [],
  data() {
    return {
      classLabel: '',
      greaterThan: '>',
      lessThan: '<',
      columns: myRankColumns,
      list: [],
      pagination: {
        total:0,
        pageSize:20,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `总共${total}个记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
      xAxisData: [],
      seriesData: [],
      eachartsRefresh: 0,
      sortParams: {
        ascs: 'weightCostRatioRank',
        descs: undefined,
      }
    }
  },
  watch: {
    sortParams: {
      handler(){
        this.getList({current: 1,pageSize: 20})
      },
      deep: true,
    },
    classLabel(){
      this.getList()
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.getList({current: 1,pageSize: 20})
    this.myOverview()
  },
  methods: {
    openTips(i){
      let content = null,title = null
      if(i === 0){
        title = '数据分类说明'
        content = <div>
          {/* <h3 class="bold" >数据统计说明</h3> */}
          1、<span class="bold">单阶段数据</span>：如教槽、保育前期等，指实证中仅填写单一阶段的数据。若填写阶段超出1个，则不属于单阶段数据。<br />
          2、<span class="bold">全程数据</span>：指实证体重区间≥100kg，或填写全部7个实证阶段的数据<br />
          3、<span class="bold">其他</span>：指即不属于单阶段，又不属于全程的数据。<span class="red">该类数据正常纳入统计，暂不纳入分析</span><br />
          4、<span class="bold">异常数据</span>：指料肉比异常（{this.lessThan}0.5或{this.greaterThan}10 ）或造肉成本异常（{this.lessThan}1 或{this.greaterThan}20）的数据。<span class="red">该类数据正常纳入统计，暂不纳入分析</span>
        </div>
      } else {
        title = '同阶段排名说明'
        content = <div>
          根据当前数据所属的“数据分类”，每条数据仅参与对应分类（即阶段）的排名。<br />
          示例：<br />
          若某条<span class="red">教槽阶段</span>数据显示料肉比<span class="red">同阶段排名前50%</span>，代表在全BU的数据范围内，所有“教槽”阶段的数据进行实时排名后，该数据位于45%-50%分位
        </div>
      }
      this.$info({
        width: 600,
        title,
        content,
        onOk() {},
      });
    },
    changeSort(field,val){
      this.sortParams = {
        ascs: field === 'ascs' ? val : undefined,
        descs:  field === 'descs' ? val : undefined,
      }
    },
    async getList(pagination){
      let {current=1,pageSize=20} = pagination || this.pagination
      let params = {
        current,size:pageSize,
        label: this.classLabel ? this.classLabel : undefined,
        ...this.sortParams,
      }
      let res = await api.mineRank(params)
      let {success,data} = res || {}
      if(success){
        let {records,current=1,total=0,size=20} = data;
        this.pagination.current = current
        this.pagination.pageSize = size
        this.pagination.total = total
        this.list = records || []
      }
    },
    async myOverview(){
      let res = await api.mineOverview()
      let {success,data} = res || {}
      if(success){
        this.xAxisData = data.map(el => el.labelName)
        this.seriesData = data.map(el => el.num)
        this.eachartsRefresh = this.eachartsRefresh + 1
      }
    },
  },
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>